import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import { appSettings } from "@/app.settings";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "ru",
  messages: loadLocaleMessages()
});

const loadedLocales = ["en", "ru"];

function getMessages(lang) {
  let url = appSettings.baseUrl + `/personal/api/v1/languages/${lang}`
  return axios.get(url);
}

export function loadLocale(locale, callback) {
  if (loadedLocales.includes(locale)) {
    callback(i18n.getLocaleMessage(locale));
    return;
  }
  getMessages(locale).then(
    resp => {
      i18n.setLocaleMessage(locale, resp.data);
      loadedLocales.push(locale);
      callback(resp.data);
    },
    err => {
      console.log(err);
      callback(i18n.getLocaleMessage(process.env.VUE_APP_I18N_LOCALE));
    }
  );
}

export default i18n;

function loadLocaleMessages() {
  const messages = {};
  loadDefaultLocales(messages);
  let localeStorage = localStorage.getItem("locale");
  let localeMessagesStorage = localStorage.getItem("localeMessages");
  if (localeStorage !== null) {
    if (localeMessagesStorage !== null) {
      messages[localeStorage] = localeMessagesStorage;
    }
    getMessages(localeStorage).then(
      (resp) => {
        localStorage.setItem("localeMessages", resp.data);  
        messages[localeStorage] = resp.data;
      },
      err => {
        console.log(err);
      }
    );
  }  
  loadDefaultLocalesFromAPI(messages);
  return messages;
}

function loadDefaultLocales(messages) {
  const locales = require.context(
    "./locale",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
}

function loadDefaultLocalesFromAPI(messages) {
  getMessages("ru").then(
    (resp) => {
      messages["ru"] = resp.data;
    },
    err => {
      console.log(err);
    }
  );
  getMessages("en").then(
    resp => {
      messages["en"] = resp.data;
    },
    err => {
      console.log(err);
    }
  );
}
